import * as React from 'react';

import { createUIContext } from '../../internals/createContext';

/* ─────────────────────────── Navbar Context ─────────────────────────────── */

export interface NavbarContextValue {
  mobileOpen: boolean;
  onMobileOpenChange: (open: boolean) => void;
  /** ID of the currently open dropdown (NavDropdown or ProfileMenu). `null` = all closed. */
  openDropdownId: string | null;
  setOpenDropdownId: (id: string | null) => void;
}

export const [NavbarProvider, useNavbarContext] = createUIContext<NavbarContextValue>('Navbar');
